<template>
  <FlexTable class="drag-table">
    <slot name="header"></slot>
    <div class="content-cols">
      <slot name="left-column"></slot>
      <draggable
          v-model="listData"
          chosenClass="drag-chosen"
          class="drag-content"
          :class="{'drag-placeholder': showPlaceholder, ...dragContentClasses }"
          :data-placeholder="placeholder"
          animation="200"
          :handle="handle"
          @start="dragStart"
          @end="dragEnd"
          @add="dragAdd"
          @update="dragUpdate"
          :group="{name: group}"
          delay="delay"
      >
        <transition-group tag="div" class="transition-group" type="transition" :name="'drag-transition'">
          <slot name="draggable"></slot>
        </transition-group>
      </draggable>
      <slot name="right-column"></slot>
    </div>
    <slot name="footer"></slot>
  </FlexTable>
</template>

<script>
  import FlexTable from './FlexTable'
  import draggable from 'vuedraggable'

  export default {
    name: 'DragTable',
    components: { FlexTable, draggable },
    model: {
      prop: 'list',
      event: 'change',
    },
    props: {
      list: Array,
      group: String,
      handle: String,
      placeholder: {
        type: String,
        default: ""
      },
      delay: {
        type: Number,
        default: 0,
      },
      dragContentClasses: {
        type: Object,
        default: function () {
          return {}
        }
      }
    },
    data: function () {
      return {
        listData: this.list,
        drag: false,
      }
    },
    computed: {
      showPlaceholder: function () {
        return (this.placeholder && !(this.listData && this.listData.length > 0))
      }
    },
    methods: {
      dragStart () {
        this.drag = true
      },
      dragEnd () {
        this.drag = false
      },
      dragAdd (evt) {
        const index = evt.newIndex
        this.landingAnimation(evt.target.children[index])
        this.$emit("drag-add", index);
      },
      dragUpdate (evt) {
        this.landingAnimation(evt.item)
      },
      landingAnimation (item) {
        // Makes smooth landing transition by re-inserting drag classes and removing them after re-render
        item.classList.add('drag-entered', 'drag-ghost', 'drag-chosen')
        this.$forceUpdate()
        this.$nextTick(() => item.classList.remove('drag-entered', 'drag-ghost', 'drag-chosen'))
      },
    },
    mounted () {
      // Remove overlay image of dragged element by replacing it with an empty element
      this.$el.addEventListener('dragstart', function (event) {
        const crt = document.createElement('div')
        event.dataTransfer.setDragImage(crt, 0, 0)
      }, false)
    },
    watch: {
      listData: function (val) {
        this.$emit('change', val)
      },
    },
  }
</script>

<style lang="scss">
  .drag-table {
    & .content-cols {
      display: flex;
    }
    & .drag-content {
      width: 100%;
      min-height: $table-row-min-height;
      position: relative;

      & .flex-trow {
        transition-property: margin, box-shadow, border-radius, background-color;
        transition-duration: 0.15s;
      }

      &.drag-placeholder {
        position: sticky;
        left: 0;
        right: 0;
      }

      &.drag-placeholder:after {
        content: attr(data-placeholder);
        display: flex;
        justify-content: center;
        align-items: center;
        text-align: center;
        width: 100%;
        background-color: $gray-100;
        color: $body-color;
        opacity: 0.7;
        border: 1px solid $gray-400;
        min-height: inherit;
      }
    }


    & .drag-entered {
      transition: none !important;
    }

    & .drag-transition-leave-active {
      display: none !important;
    }

    & .drag-chosen {
      z-index: $zindex-tooltip;
      cursor: move;
      margin-top: 8px;
      margin-bottom: 8px;
      background-color: rgba(theme-color('primary'), 0.05);
      box-shadow: 1px 1px 4px 0 rgba(theme-color-level('primary', 10), 0.5);
      border-radius: 8px;

      & * {
        border-color: transparent !important;
      }
    }
  }

</style>